export default function SvgLaugh() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 48 48"
        viewBox="0 0 48 48"
        width="30px"
        cursor="pointer"
      >
        <g>
          <circle cx="24" cy="24" r="12.244" fill="#FFD872"></circle>
          <path
            fill="#303030"
            d="M31.849 24.022c0 10.462-15.698 10.462-15.698 0H31.85z"
          ></path>
          <path
            fill="#F45368"
            d="M31.055 27.697c-4.132-1.851-10.013-1.784-14.024.181 3.327 5.744 11.33 5.059 14.024-.181z"
          ></path>
          <circle
            cx="24"
            cy="24"
            r="12.244"
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          ></circle>
          <path
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
            d="M31.84887 21.62552L28.73835 19.79409 31.84887 17.99956"
          ></path>
          <path
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
            d="M16.45646 21.62552L19.56698 19.79409 16.45646 17.99956"
          ></path>
          <path
            fill="none"
            stroke="#303030"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
            d="M31.849 24.022c0 10.462-15.698 10.462-15.698 0H31.85zM17.03 27.878c4.012-1.965 9.893-2.032 14.025-.181"
          ></path>
        </g>
      </svg>
    </>
  );
}
